import { useQuery } from '@tanstack/react-query';
import { IRealEstateUseType } from '../../Interfaces/IRealEstateUseType';
import { customFetcher } from '../useFetch';

//////////////////// RealEstateUseTypes
export const useGeRealEstateUseTypes = () => {
  const { data: realEstateUseTypes, isLoading: isLoadingRealEstateUseTypes } =
    useQuery<IRealEstateUseType[]>({
      refetchOnWindowFocus: false,
      queryKey: ['realestateusetype'],
      queryFn: () =>
        customFetcher({
          endpoint: '/realestateusetype',
        }),
    });

  return { realEstateUseTypes, isLoadingRealEstateUseTypes };
};
